import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FiMail,
  FiPhone,
  FiSend,
  FiMapPin,
  FiClock,
  FiInstagram,
  FiFacebook,
  FiMessageCircle,
} from "react-icons/fi";
import { FaTiktok } from "react-icons/fa";
import axios from "axios";
import Footer from "../components/Footer";
import backgroundImg from "../assets/logo.jpg";
import logo2 from "../assets/logo2.png";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5000";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [status, setStatus] = useState({ success: null, message: "" });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isMounted, setIsMounted] = useState(false);

  // Inject styles
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 100);

    const styleSheet = document.createElement("style");
    styleSheet.type = "text/css";
    styleSheet.innerText = styles;
    document.head.appendChild(styleSheet);

    return () => {
      clearTimeout(timer);
      setIsMounted(false);
      if (styleSheet.parentNode) {
        styleSheet.parentNode.removeChild(styleSheet);
      }
    };
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus({ success: null, message: "" });

    try {
      await axios.post(`${apiUrl}/api/emails/contact`, formData);
      setStatus({ success: true, message: "Message envoyé avec succès !" });
      setFormData({ name: "", email: "", subject: "", message: "" });
    } catch (err) {
      setStatus({
        success: false,
        message: "Erreur lors de l'envoi du message.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const contactInfo = [
    {
      icon: <FiMail />,
      title: "Email",
      value: "safastep@gmail.com",
      link: "mailto:safastep@gmail.com",
    },
    {
      icon: <FiPhone />,
      title: "Téléphone",
      value: "+212 706-696865",
      link: "tel:+212706696865",
    },
    {
      icon: <FiMapPin />,
      title: "Localisation",
      value: "Maroc",
      link: null,
    },
    {
      icon: <FiClock />,
      title: "Horaires",
      value: "7j sur 7, 24h sur 24",
      link: null,
    },
  ];

  const socialLinks = [
    {
      icon: <FiInstagram />,
      href: "https://www.instagram.com/safa.step?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==",
      color: "#E1306C",
      label: "Instagram",
    },
    {
      icon: <FiFacebook />,
      href: "https://www.facebook.com/bensonshoesmaroc",
      color: "#3b5998",
      label: "Facebook",
    },
    {
      icon: <FaTiktok />,
      href: "https://vm.tiktok.com/ZMSWhaDSQ/",
      color: "#000",
      label: "TikTok",
    },
  ];

  if (!isMounted) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          background: "linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%)",
          fontFamily: "'Cormorant Garamond', serif",
        }}
      >
        <div
          style={{
            textAlign: "center",
            color: "#2c1810",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "3px solid rgba(212, 175, 55, 0.2)",
              borderTop: "3px solid #d4af37",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          ></div>
          <p style={{ fontSize: "1.2rem", fontWeight: "600" }}>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="contact-container">
      <div style={{ height: window.innerWidth <= 768 ? "4vh" : "10vh" }}></div>

      {/* Main Content */}
      <section className="contact-content">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true, margin: "-100px" }}
          className="contact-grid"
        >
          {/* Contact Information */}
          <motion.div
            className="contact-info-section"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>
              Nos <span className="contact-highlight">coordonnées</span>
            </h2>

            <div className="contact-info-grid">
              {contactInfo.map((info, index) => (
                <motion.div
                  key={index}
                  className="contact-info-card"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  whileHover={{ y: -5 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                >
                  <div className="info-icon">{info.icon}</div>
                  <div className="info-content">
                    <h3>{info.title}</h3>
                    {info.link ? (
                      <a href={info.link} className="info-link">
                        {info.value}
                      </a>
                    ) : (
                      <span>{info.value}</span>
                    )}
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              className="social-section"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <h3>Suivez-nous</h3>
              <div className="social-links">
                {socialLinks.map((social, index) => (
                  <motion.a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    style={{ "--social-color": social.color }}
                    whileHover={{ scale: 1.1, y: -5 }}
                    whileTap={{ scale: 0.95 }}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                  >
                    {social.icon}
                    <span className="social-label">{social.label}</span>
                  </motion.a>
                ))}
              </div>
            </motion.div>
          </motion.div>

          {/* Contact Form */}
          <motion.div
            className="contact-form-section"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2>
              Envoyez-nous un <br />{" "}
              <span className="form-highlight">message</span>
            </h2>

            {status.message && (
              <motion.div
                className={`status-message ${
                  status.success ? "success" : "error"
                }`}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
              >
                {status.message}
              </motion.div>
            )}

            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-row">
                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.1 }}
                  viewport={{ once: true }}
                >
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Votre nom complet"
                    required
                    className="form-input"
                  />
                </motion.div>

                <motion.div
                  className="form-group"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Votre adresse email"
                    required
                    className="form-input"
                  />
                </motion.div>
              </div>

              <motion.div
                className="form-group"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.3 }}
                viewport={{ once: true }}
              >
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Sujet de votre message"
                  className="form-input"
                />
              </motion.div>

              <motion.div
                className="form-group"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Votre message..."
                  rows="6"
                  required
                  className="form-textarea"
                />
              </motion.div>

              <motion.button
                type="submit"
                className="submit-button"
                disabled={isSubmitting}
                whileHover={{ scale: 1.05, y: -2 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.5 }}
                viewport={{ once: true }}
              >
                {isSubmitting ? (
                  <div className="loading-spinner" />
                ) : (
                  <>
                    <FiSend />
                    Envoyer le message
                  </>
                )}
              </motion.button>
            </form>
          </motion.div>
        </motion.div>
      </section>

      <Footer />
    </div>
  );
};

export default ContactPage;

// CSS liquid glass élégant et traditionnel inspiré de Home.jsx
const styles = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700;800;900&family=Cormorant+Garamond:wght@300;400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap');

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  font-family: 'Cormorant Garamond', serif;
  background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
}

.contact-container {
  font-family: 'Cormorant Garamond', serif;
  color: #2c1810;
  margin: 0 auto;
  overflow-x: hidden;
  background: linear-gradient(135deg, #f8f5f0 0%, #f0ebe0 100%);
}

/* Hero Section */
.hero-section {
  position: relative;
  height: 100vh;
  min-height: 600px;
  background-image: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${backgroundImg});
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  margin-bottom: 60px;
}

.hero-section::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 300px;
  background-image: url(${logo2});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.05;
  z-index: 1;
  pointer-events: none;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
}

.hero-content {
  position: relative;
  z-index: 3;
  padding: 0 20px;
}

.hero-content h1 {
  font-size: 3.5rem;
  font-weight: 600;
  margin-bottom: 20px;
  letter-spacing: 1px;
  text-shadow: 2px 2px 8px rgba(0,0,0,0.6);
  font-family: 'Cormorant Garamond', serif;
}

.hero-content p {
  font-size: 1.3rem;
  font-style: italic;
  text-shadow: 1px 1px 4px rgba(0,0,0,0.5);
  font-family: 'Cormorant Garamond', serif;
}

.divider {
  height: 2px;
  width: 80px;
  background: #d4af37;
  margin: 25px auto;
  transform-origin: center;
  border-radius: 1px;
}

.scroll-hint {
  position: absolute;
  bottom: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.scroll-hint span {
  font-size: 14px;
  margin-bottom: 5px;
  font-family: 'Cormorant Garamond', serif;
}

.scroll-hint::after {
  content: "";
  width: 20px;
  height: 30px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 10px;
}

.scroll-hint::before {
  content: "";
  width: 4px;
  height: 8px;
  background: white;
  border-radius: 2px;
  position: absolute;
  bottom: 8px;
  animation: scrollHint 2s infinite;
}

@keyframes scrollHint {
  0% { transform: translateY(0); opacity: 0; }
  50% { transform: translateY(5px); opacity: 1; }
  100% { transform: translateY(10px); opacity: 0; }
}

/* Main Content */
.contact-content {
  margin: 0 auto;
  padding: 60px 30px;
  position: relative;
  z-index: 2;
}

.contact-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
  max-width: 1200px;
  margin: 0 auto;
}

/* Contact Info Section */
.contact-info-section {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 20px;
  padding: 40px 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.contact-info-section::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 200px;
  height: 200px;
  background-image: url(${logo2});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.03;
  z-index: 1;
  pointer-events: none;
}

.contact-info-section h2 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 35px;
  color: #2c1810;
  text-align: center;
  position: relative;
  z-index: 3;
  font-family: 'Cormorant Garamond', serif;
}

.contact-highlight {
  position: relative;
  color: #d4af37;
}

.contact-highlight::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background: rgba(212, 175, 55, 0.2);
  z-index: -1;
  border-radius: 4px;
}

.contact-info-grid {
  display: grid;
  gap: 20px;
  margin-bottom: 40px;
  position: relative;
  z-index: 3;
}

.contact-info-card {
  display: flex;
  align-items: center;
  padding: 20px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  border: 1px solid rgba(212, 175, 55, 0.2);
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.contact-info-card:hover {
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.2);
  transform: translateY(-2px);
  border: 1px solid rgba(212, 175, 55, 0.3);
}

.info-icon {
  width: 45px;
  height: 45px;
  background: rgba(212, 175, 55, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d4af37;
  font-size: 1.2rem;
  margin-right: 18px;
  flex-shrink: 0;
  box-shadow: 0 4px 16px rgba(212, 175, 55, 0.1);
  border: 1px solid rgba(212, 175, 55, 0.2);
}

.info-content h3 {
  font-size: 14px;
  font-weight: 600;
  color: #2c1810;
  margin-bottom: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Cormorant Garamond', serif;
}

.info-content span,
.info-link {
  font-size: 16px;
  color: #5a4a3a;
  text-decoration: none;
  font-weight: 400;
  font-family: 'Cormorant Garamond', serif;
}

.info-link:hover {
  color: #d4af37;
}

/* Social Section */
.social-section {
  text-align: center;
  position: relative;
  z-index: 3;
}

.social-section h3 {
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 25px;
  color: #2c1810;
  font-family: 'Cormorant Garamond', serif;
}

.social-links {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.social-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  border: 1px solid rgba(212, 175, 55, 0.2);
  color: #2c1810;
  text-decoration: none;
  transition: all 0.3s ease;
  min-width: 90px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
}

.social-link:hover {
  background: var(--social-color);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(0,0,0,0.2);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.social-link svg {
  font-size: 1.5rem;
  margin-bottom: 8px;
}

.social-label {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-family: 'Cormorant Garamond', serif;
}

/* Contact Form Section */
.contact-form-section {
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 20px;
  padding: 40px 35px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
}

.contact-form-section::before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  width: 120px;
  height: 120px;
  background-image: url(${logo2});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.03;
  z-index: 1;
  pointer-events: none;
}

.contact-form-section h2 {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 35px;
  color: #2c1810;
  text-align: center;
  position: relative;
  z-index: 3;
  font-family: 'Cormorant Garamond', serif;
}

.form-highlight {
  position: relative;
  color: #d4af37;
}

.form-highlight::after {
  content: "";
  position: absolute;
  bottom: 5px;
  left: 0;
  width: 100%;
  height: 8px;
  background: rgba(212, 175, 55, 0.2);
  z-index: -1;
  border-radius: 4px;
}

.status-message {
  padding: 15px 20px;
  border-radius: 15px;
  margin-bottom: 25px;
  font-weight: 500;
  text-align: center;
  position: relative;
  z-index: 3;
  font-family: 'Cormorant Garamond', serif;
}

.status-message.success {
  background: rgba(76, 175, 80, 0.1);
  color: #2e7d32;
  border: 1px solid rgba(76, 175, 80, 0.3);
}

.status-message.error {
  background: rgba(244, 67, 54, 0.1);
  color: #c62828;
  border: 1px solid rgba(244, 67, 54, 0.3);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  position: relative;
  z-index: 3;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-input,
.form-textarea {
  width: 100%;
  padding: 15px 18px;
  border: 1px solid rgba(212, 175, 55, 0.2);
  border-radius: 15px;
  font-size: 16px;
  font-family: 'Cormorant Garamond', serif;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  transition: all 0.3s ease;
  box-sizing: border-box;
  color: #2c1810;
}

.form-input:focus,
.form-textarea:focus {
  outline: none;
  border-color: #d4af37;
  background: rgba(255, 255, 255, 0.15);
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
}

.form-input::placeholder,
.form-textarea::placeholder {
  color: #5a4a3a;
  font-weight: 400;
  font-family: 'Cormorant Garamond', serif;
}

.form-textarea {
  resize: vertical;
  min-height: 120px;
}

.submit-button {
  padding: 15px 30px;
  background: rgba(212, 175, 55, 0.2);
  color: #2c1810;
  border: 1px solid rgba(212, 175, 55, 0.3);
  border-radius: 15px;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Cormorant Garamond', serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  transition: all 0.3s ease;
  margin-top: 20px;
  align-self: flex-start;
  box-shadow: 0 4px 16px rgba(212, 175, 55, 0.2);
  text-transform: uppercase;
}

.submit-button:hover:not(:disabled) {
  background: rgba(212, 175, 55, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(212, 175, 55, 0.3);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(44, 24, 16, 0.3);
  border-top: 2px solid #2c1810;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Responsive Design */
@media (max-width: 1024px) {
  .contact-grid {
    gap: 40px;
  }
  
  .contact-info-section,
  .contact-form-section {
    padding: 35px 30px;
  }
}

@media (max-width: 768px) {
  .hero-content h1 {
    font-size: 2.5rem;
  }
  
  .hero-content p {
    font-size: 1.1rem;
  }
  
  .contact-content {
    padding: 50px 20px;
  }
  
  .contact-grid {
    grid-template-columns: 1fr;
    gap: 35px;
  }
  
  .contact-info-section,
  .contact-form-section {
    padding: 30px 25px;
  }
  
  .contact-info-section h2,
  .contact-form-section h2 {
    font-size: 1.8rem;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .social-links {
    flex-wrap: wrap;
    gap: 7px;
  }
  
  .social-link {
    min-width: 80px;
       padding: 10px 15px;

  }
  
  .submit-button {
    width: 100%;
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 2rem;
  }
  
  .contact-content {
    padding: 40px 15px;
  }
  
  .contact-info-section,
  .contact-form-section {
    padding: 25px 20px;
  }
  
  .contact-info-card {
    padding: 18px;
  }
  
  .info-icon {
    width: 40px;
    height: 40px;
    font-size: 1.1rem;
    margin-right: 15px;
  }
  
  .form-input,
  .form-textarea {
    padding: 14px 16px;
    font-size: 15px;
  }
}
`;
